/**
 * @fileoverview added by tsickle
 * Generated from: pipes/money-pipes.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import { Pipe } from '@angular/core';
/**
 * This shows pounds with either zero or two decimal places.
 */
import * as ɵngcc0 from '@angular/core';
var AsGbp = /** @class */ (function () {
    function AsGbp() {
    }
    /**
     * @param {?} pounds
     * @param {?=} alwaysShowPence
     * @return {?}
     */
    AsGbp.prototype.transform = /**
     * @param {?} pounds
     * @param {?=} alwaysShowPence
     * @return {?}
     */
    function (pounds, alwaysShowPence) {
        if (alwaysShowPence === void 0) { alwaysShowPence = false; }
        /** @type {?} */
        var poundsNum;
        if (typeof pounds === 'string') {
            poundsNum = parseFloat((/** @type {?} */ (pounds)));
        }
        else {
            poundsNum = pounds;
        }
        /** @type {?} */
        var currencySymbol = '£';
        /** @type {?} */
        var amountString;
        /** @type {?} */
        var hasPence = poundsNum % 1 !== 0;
        if (hasPence || alwaysShowPence) {
            amountString = poundsNum.toFixed(2);
        }
        else {
            amountString = poundsNum.toString();
        }
        return "" + currencySymbol + amountString;
    };
AsGbp.ɵfac = function AsGbp_Factory(t) { return new (t || AsGbp)(); };
AsGbp.ɵpipe = /*@__PURE__*/ ɵngcc0.ɵɵdefinePipe({ name: "asGbp", type: AsGbp, pure: true });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AsGbp, [{
        type: Pipe,
        args: [{ name: 'asGbp' }]
    }], function () { return []; }, null); })();
    return AsGbp;
}());
export { AsGbp };

